import { SpotlightDocumentSchema } from "@redotech/redo-model/spotlight-document-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTeamCheckoutProbabilitySpotlights = {
  name: "getTeamCheckoutProbabilitySpotlights" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(SpotlightDocumentSchema),
};
